import React from "react";

import { FormControl, FormLabel, Grid, TextField } from "@mui/material";

import TemplateListTable from "./template-list-table";

interface InspectionLoaderFormProps {
  templatesList: string[];
  setTemplatesList: (newTemplateList: string[]) => void;
  inspectionsCount: number;
  setInspectionsCount: (newInspectionsCount: number) => void;
}

const InspectionLoaderForm = ({
  templatesList,
  setTemplatesList,
  inspectionsCount,
  setInspectionsCount,
}: InspectionLoaderFormProps) => {
  return (
    <FormControl fullWidth>
      <TemplateListTable
        templatesList={templatesList}
        setTemplatesList={setTemplatesList}
      />
      <Grid container direction="row" alignItems="center" paddingTop={1}>
        <Grid item xs={6}>
          <FormLabel required>Number of inspections per template</FormLabel>
        </Grid>
        <Grid item xs={3}></Grid>
        <Grid item xs={3}>
          <TextField
            id="inspections-loader-quantity-input"
            value={inspectionsCount.toString()}
            fullWidth
            type="number"
            onChange={(e) => {
              let count = parseInt(e.target.value);
              if (count > 1000) {
                count = 1000;
              }
              if (Number.isNaN(count) || count < 0) {
                count = 0;
              }
              setInspectionsCount(Math.abs(count));
            }}
            margin="normal"
            variant="outlined"
            InputProps={{
              inputProps: {
                "data-testid": "inspections-loader-quantity-input",
              },
            }}
          />
        </Grid>
      </Grid>
    </FormControl>
  );
};

export default InspectionLoaderForm;
